const pageNameKey = "machinesRemoteSupportRequestedButton";

export const machinesRemoteSupportRequestedButtonEn = {
  [pageNameKey]: {
    viewDetails: "View request details",
    cancel: "Cancel Request",
    requestedIcon: "Requested Icon",
    joinSessionIcon: "Join session icon",
    readyToStart: "Ready to start",
    awaitingTechnician: "Awaiting Technician",
    awaitingTechnicianTooltip:
      "The session is waiting to start.\nYou'll be able to join once the technician begins screen sharing.",
  },
};

export const machinesRemoteSupportRequestedButtonPtBr = {
  [pageNameKey]: {
    viewDetails: "Ver detalhes da solicitação",
    cancel: "Cancelar solicitação",
    requestedIcon: "Ícone solicitado",
    joinSessionIcon: "Ícone entrar na sessão",
    readyToStart: "Pronto para iniciar",
    awaitingTechnician: "Aguardando técnico",
    awaitingTechnicianTooltip:
      "A sessão está aguardando para iniciar.\nVocê poderá entrar quando o técnico começar o compartilhamento de tela.",
  },
};

export const machinesRemoteSupportRequestedButtonDe = {
  [pageNameKey]: {
    viewDetails: "Anforderungsdetails anzeigen",
    cancel: "Anfrage abbrechen",
    requestedIcon: "Angefordertes Symbol",
    joinSessionIcon: "Sitzung beitreten Symbol",
    readyToStart: "Bereit zum Start",
    awaitingTechnician: "Warten auf Techniker",
    awaitingTechnicianTooltip:
      "Die Sitzung wartet auf den Start.\nSie können beitreten, sobald der Techniker mit der Bildschirmfreigabe beginnt.",
  },
};

export const machinesRemoteSupportRequestedButtonZhHans = {
  [pageNameKey]: {
    viewDetails: "查看请求详情",
    cancel: "取消请求",
    requestedIcon: "请求的图标",
    joinSessionIcon: "加入会话图标",
    readyToStart: "准备开始",
    awaitingTechnician: "等待技术人员",
    awaitingTechnicianTooltip:
      "会话正在等待开始。\n技术人员开始共享屏幕后，您将可以加入。",
  },
};

export const machinesRemoteSupportRequestedButtonIt = {
  [pageNameKey]: {
    viewDetails: "Visualizza i dettagli della richiesta",
    cancel: "Annulla richiesta",
    requestedIcon: "Icona richiesta",
    joinSessionIcon: "Icona partecipa sessione",
    readyToStart: "Pronto per iniziare",
    awaitingTechnician: "In attesa del tecnico",
    awaitingTechnicianTooltip:
      "La sessione è in attesa di iniziare.\nPotrai unirti quando il tecnico inizierà la condivisione dello schermo.",
  },
};

export const machinesRemoteSupportRequestedButtonEs = {
  [pageNameKey]: {
    viewDetails: "Ver detalles de la solicitud",
    cancel: "Cancelar solicitud",
    requestedIcon: "Icono solicitado",
    joinSessionIcon: "Icono unirse a la sesión",
    readyToStart: "Listo para iniciar",
    awaitingTechnician: "Esperando al técnico",
    awaitingTechnicianTooltip:
      "La sesión está esperando para comenzar.\nPodrá unirse cuando el técnico inicie el uso compartido de pantalla.",
  },
};

export const machinesRemoteSupportRequestedButtonNl = {
  [pageNameKey]: {
    cancel: "Verzoek annuleren",
    requestedIcon: "Aangevraagd-pictogram",
    viewDetails: "Verzoekdetails weergeven",
    joinSessionIcon: "Pictogram deelnemen aan sessie",
    readyToStart: "Klaar om te starten",
    awaitingTechnician: "Wachten op technicus",
    awaitingTechnicianTooltip:
      "De sessie wacht om te starten.\nU kunt deelnemen zodra de technicus het scherm begint te delen.",
  },
};

export const machinesRemoteSupportRequestedButtonTr = {
  [pageNameKey]: {
    awaitingTechnician: "Beklenen Teknisyen",
    awaitingTechnicianTooltip:
      "Oturumun başlaması bekleniyor.\\nTeknisyen ekran paylaşımına başladığında oturuma katılabileceksiniz.",
    cancel: "İsteği İptal Et",
    joinSessionIcon: "Oturuma katıl simgesi",
    readyToStart: "Başlamaya hazır",
    requestedIcon: "İstenen Simge",
    viewDetails: "İstek ayrıntılarını görüntüle",
  },
};
